function sanitizeTitle(title) {
    // Helper function to remove accents
    function removeAccents(str) {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    // Convert to lowercase
    title = title.toLowerCase();

    // Remove accents
    title = removeAccents(title);

    // Replace spaces and special characters with hyphens
    title = title.replace(/[^a-z0-9]+/g, "-");

    // Remove leading and trailing hyphens
    title = title.replace(/^-+|-+$/g, "");

    return title;
}

export {sanitizeTitle};